import(/* webpackMode: "eager" */ "/codebuild/output/src1875186150/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/page.tsx");
